
import { useEffect } from 'react';
import { BookingFormData } from '../../ParcelBookingForm';
import { isValidPhoneNumber } from 'react-phone-number-input';

export const useMultiContactValidation = (
  formData: BookingFormData,
  onValidationChange?: (isValid: boolean) => void
) => {
  const validateContact = (contact: any) => {
    return (
      contact.name.trim() !== '' &&
      contact.phone.trim() !== '' &&
      isValidPhoneNumber(contact.phone) &&
      contact.email.trim() !== '' &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email)
    );
  };

  const isContactsValid = 
    formData.collectionContacts.length > 0 &&
    formData.deliveryContacts.length > 0 &&
    formData.collectionContacts.every(validateContact) &&
    formData.deliveryContacts.every(validateContact) &&
    formData.collectionContacts.some(c => c.isPrimary) &&
    formData.deliveryContacts.some(c => c.isPrimary);

  useEffect(() => {
    if (onValidationChange) {
      onValidationChange(isContactsValid);
    }
  }, [isContactsValid, onValidationChange]);

  return { isContactsValid };
};
